export interface ControlTableSecurity {
  SecIndex: number;
  SecNumber: string;
  SecISIN: string;
  SecStockExchange: number;
  SecSymbol: string;
  SecName: string;
  SecCurrSymbol: string;
  FxRate: number;
  StockExchangeCode: string;
  StockExchangeName: string;
  EODHDStockExchangeCode: string;
  SecType: number;
  SecCurr: number;
  SecFactor: number;
  SecContractSize: number;
}

export interface Watchlist {
  WatchlistID: number;
  WatchlistName: string;
}

export const FAVOURITES_WATCHLIST_ID = 0;

export const FAVOURITES_WATCHLIST_NAME = "Favourites";

export const MAX_WATCHLIST_SECURITIES = 30;

// Favoriti = traderovi favoriti (tbTraderLoginSecFavourites); backend
// (TraderFavouritesInsert) tiho ne dodaje više od 10.
export const MAX_FAVOURITES = 10;

export function isFavouritesWatchlist(id: number | null): boolean {
  return id === FAVOURITES_WATCHLIST_ID;
}

export interface ControlTableRow {
  security: ControlTableSecurity;
  isDomestic: boolean;

  price: number | null;
  lastClose: number | null;
  bestBid: number | null;
  bestBidQty: number | null;
  bestAsk: number | null;
  bestAskQty: number | null;
  open: number | null;
  high: number | null;
  low: number | null;
  volume: number | null;
  tradingPhase: string | null;
  priceRange: string | null;
  currency: string | null;

  priceDir: "" | "up" | "down";

  loading: boolean;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-control-table/control-table.models.ts